module.exports = __webpack_public_path__ + "static/media/3.eaa1804a.jpg";